export default __webpack_public_path__ + "static/media/no_data_available.d0712b27.svg";